<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { Head, Link } from '@inertiajs/inertia-vue3'
import Faqinfo from './Faqinfo.json'
import stripslashes, { replaceS3path } from '@/Shared/helper.js'
import ButtonBack from '@/Shared/Buttons/ButtonBack'
import usePref from '@/Shared/usePref.js'
import TextFor from '@/Shared/Icons/TextFor'

const props = defineProps({
  faq: Object,
  id: String,
  pref: Object,
})

const getCategoryInfo = () => {
  const r = Faqinfo.filter((i) => i.slug == props.faq[0].faqCategory)
  return r
}

const getBrandThumb = (slug) => {
  let thum = '//img.aandf.co.jp/aandfcojp/img/brands/logo_af_original.svg'
  let r = []
  if (slug != 'all') {
    r = props.pref.brands.filter((i) => i.brandSlug == slug)
    thum = replaceS3path(r[0].brandThumb)
  }
  return thum
}

const getBrandName = (brand) => {
  const str = brand !== 'all' ? getBrandNameJ(brand) : 'すべてのブランド'
  return str
}

const getBrandNameJ = (brand) => {
  const nameJ = props.pref.brands.filter((item) => item.brandSlug === brand)[0].brandNameLocal
  return nameJ
}

const addH2SmallText = () => {
  let r = 'ユーザの方へ'
  if (props.faq) {
    let i = getCategoryInfo()
    r = i[0].nameJ
  }
  return r
}

const back = () => {
  window.history.back()
}

const getTitle = () => {
  return props.faq[0].faqTitle
}

const getTxt = () => {
  return props.faq[0].faqTxt
}

const getTxt2 = () => {
  return props.faq[0].faqTxt2
}

const getTxt3 = () => {
  return props.faq[0].faqTxt3
}

const getFaqImg = (img) => {
  if (img.includes('http') || img.includes('https')) {
    return img
  } else {
    const p = '//img.aandf.co.jp.s3.amazonaws.com/aandfcojp/img/faq/' + img
    const r = replaceS3path(p)
    return r
  }
}

onMounted(() => {
  usePref(props.pref)
})

onUnmounted(() => {})
</script>

<template>
  <div class="faq-detail">
    <Head title="FAQ DETAIL" />

    <div class="bg-afgreen lg:min-h-[calc(100vh_-_75px)] xl:min-h-screen lg:grid lg:items-center">
      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[80px] md:px-0 md:w-[600px] pb-[60px] sm:pb-[80px] lg:py-[100px]">
        <h2 class="page-title !text-left !pt-[0.8em] sm:!pt-[1em] lg:!pt-0 !pb-[0.4em] lg:!pb-[0.2em] text-white">
          <TextFor class="[&_svg]:fill-white" />
          USERS
          <small v-html="addH2SmallText()" />
        </h2>

        <div class="outer mt-[10px] xs:mt-[20px] sm:mt-[30px]">
          <div class="text-center">
            <img :src="getBrandThumb(faq[0].faqBrandSlug)" alt="getBrandName(faq[0].faqBrandSlug)" class="inline max-w-[70%] sm:max-w-[260px] max-h-[260px] mt-[60px] sm:mt-[70px] lg:mt-[80px] mb-[40px]" />
            <h3 class="font-bold text-[110%]" v-html="getBrandName(faq[0].faqBrandSlug)" />
          </div>
          <div class="inner">
            <div class="question">
              <div class="label">Q</div>
              <h3 v-html="getTitle()" />
            </div>

            <div class="answer">
              <div class="label">A</div>
              <div class="description">
                <p v-html="stripslashes(getTxt())" />
                <template v-if="faq[0].faqImg1">
                  <img :src="getFaqImg(faq[0].faqImg1)" alt="" />
                </template>
                <template v-if="faq[0].faqTxt2">
                  <p v-html="stripslashes(getTxt2())" />
                </template>
                <template v-if="faq[0].faqImg2">
                  <img :src="getFaqImg(faq[0].faqImg2)" alt="" />
                </template>
                <template v-if="faq[0].faqTxt3">
                  <p v-html="stripslashes(getTxt3())" />
                </template>
              </div>
            </div>
          </div>
        </div>
        <Link @click="back">
          <ButtonBack color="white" class="back" />
        </Link>
      </div>
    </div>
  </div>
</template>
